import { FETCH_BULLETIN, RESET_BULLETIN } from './constants'

export const fetchBulletin = {
  request: (page, limit) => ({
    type: FETCH_BULLETIN.REQUEST,
    page,
    limit
  }),
  success: (messages, totalCount) => ({
    type: FETCH_BULLETIN.SUCCESS,
    payload: { messages, totalCount }
  })
}

export const resetBulletin = () => ({
  type: RESET_BULLETIN
})
